import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

type PasswordTextFieldProps = {
  fieldName: string;
  label: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  sx?: object;
};

const PasswordTextField = ({ fieldName, label, onChange, sx }: PasswordTextFieldProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <TextField
      sx={{ my: '10px', ...sx }}
      label={label}
      name={fieldName}
      onChange={onChange}
      variant="outlined"
      type={showPassword ? 'text' : 'password'}
      fullWidth
      slotProps={{
        input: {
          sx: {
            borderRadius: '10px',
          },
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={togglePasswordVisibility} edge="end">
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

export default PasswordTextField;
